import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: Array<any>, category: string): Array<any> {
    return items.filter(item => item.tipo === category);
  }

}
